/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BusinessRelationStatus = {
    Draft: 'DRAFT',
    InApproval: 'IN_APPROVAL',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Rejected: 'REJECTED',
    Withdrawn: 'WITHDRAWN',
    DuplicateCheckPending: 'DUPLICATE_CHECK_PENDING',
    Approved: 'APPROVED',
    ClosureRequested: 'CLOSURE_REQUESTED',
    InClosing: 'IN_CLOSING',
    Closed: 'CLOSED'
} as const;
export type BusinessRelationStatus = typeof BusinessRelationStatus[keyof typeof BusinessRelationStatus];


export function instanceOfBusinessRelationStatus(value: any): boolean {
    for (const key in BusinessRelationStatus) {
        if (Object.prototype.hasOwnProperty.call(BusinessRelationStatus, key)) {
            if (BusinessRelationStatus[key as keyof typeof BusinessRelationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BusinessRelationStatusFromJSON(json: any): BusinessRelationStatus {
    return BusinessRelationStatusFromJSONTyped(json, false);
}

export function BusinessRelationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessRelationStatus {
    return json as BusinessRelationStatus;
}

export function BusinessRelationStatusToJSON(value?: BusinessRelationStatus | null): any {
    return value as any;
}

export function BusinessRelationStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): BusinessRelationStatus {
    return value as BusinessRelationStatus;
}

